export default __webpack_public_path__ + "static/media/search_grey.de50ed9b.svg";